export default __webpack_public_path__ + "static/media/HealthLinkBC.83b24c79.png";